export default __webpack_public_path__ + "static/media/TodayCategories.a97146c5.png";